import {
  HelpCircle,
  Home,
  Mail,
  Settings,
  Shield,
  UserIcon,
} from 'lucide-react';

import { UserRole } from '@/types/auth';

export const getDashboardNavItems = (
  username: string,
  role?: UserRole,
  invertAdmin?: boolean,
) => {
  const items = [
    {
      label: 'Feed',
      href: '/feed',
      icon: Home,
    },
    {
      label: 'Messaging',
      href: '/messages',
      icon: Mail,
    },
    {
      label: 'Profile',
      href: `/users/${username}`,
      icon: UserIcon,
    },
  ];

  if (role === 'admin') {
    if (invertAdmin) {
      items.push({
        label: 'Back to Platform',
        href: '/feed',
        icon: Home,
      });
    } else {
      items.push({
        label: 'Admin Dashboard',
        href: '/admin',
        icon: Shield,
      });
    }
  }

  items.push(
    {
      label: 'Support',
      href: '/contact',
      icon: HelpCircle,
    },
    {
      label: 'Settings',
      href: '/settings',
      icon: Settings,
    },
  );

  return items;
};
